import { StudentsIcon } from "../../../../shared/components/svgIcons";
import StudentsList from "../components/studentsList";
import StudentsView from "../components/studentsView";
import { Navigate } from "react-router-dom";

const studentsRoute = {
  path: "students",
  element: "",
  link: "/students",
  name: "Students ",
  icon: StudentsIcon,
  index: 3,
  children: [
    {
      path: "student-list",
      element: <StudentsList />,
      permission: "Students Listing",
      link: "students/student-list",
      name: "Student List",
      icon: StudentsIcon,
      index: 1,
    },
    {
      path: "student-list/:id",
      element: <StudentsView />,
    },
    {
      path: "",
      element: <Navigate to="/students/student-list" replace />,
    },
  ]
}

export default studentsRoute;